import math from './../mixins/math'
export default {
  mixins: [math],
  methods: {
    printData(url, name) {
      let fileName = `${name} ${this.getTimestamp()}.xlsx`
      this.getList(url, fileName)
    },
    getList(url, fileName) {
      this.loading = true

      const data = {
        search: this.searchData ?? null,
      }

      this.$axios
        .post(url, data, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          this.openFile(res.data, fileName)
        })
        .catch(err => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          window._VMA.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(fileData, fileName) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', this.safeFileName(fileName))
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    getTimestamp() {
      let today = new Date()
      return `${today.getFullYear()}-${this.paddingZero(
        today.getMonth() + 1
      )}-${this.paddingZero(today.getDate())} ${this.paddingZero(
        today.getHours()
      )}:${this.paddingZero(today.getMinutes())}`
    },
    paddingZero(str) {
      return String(str).padStart(2, '0')
    },
  },
}
